import type { Translations } from '@change-corgi/core/i18n';

export const getTranslations = async (
	locale: string,
	options: {
		getTranslations: (l: string) => Promise<Translations>;
	},
): Promise<Translations> => options.getTranslations(locale);
